import { render, staticRenderFns } from "./_registeredMember.vue?vue&type=template&id=4cd45ba6&scoped=true&lang=pug"
import script from "./_registeredMember.vue?vue&type=script&lang=js"
export * from "./_registeredMember.vue?vue&type=script&lang=js"
import style0 from "./_registeredMember.vue?vue&type=style&index=0&id=4cd45ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd45ba6",
  null
  
)

export default component.exports